import { useEffect, useState, useCallback } from "react";
import { readStored, writeStored, clearTokens } from "../lib/auth";
import type { AuthTokens } from "@orbit/api-zod";

interface AuthState {
  customerId: string | null;
  tokens: AuthTokens | null;
}

function snapshot(): AuthState {
  const s = readStored();
  return { customerId: s?.customerId ?? null, tokens: s?.tokens ?? null };
}

export function useAuth() {
  const [state, setState] = useState<AuthState>(snapshot);

  useEffect(() => {
    const handler = () => setState(snapshot());
    window.addEventListener("orbit:auth-changed", handler);
    window.addEventListener("storage", handler);
    return () => {
      window.removeEventListener("orbit:auth-changed", handler);
      window.removeEventListener("storage", handler);
    };
  }, []);

  const signIn = useCallback((customerId: string, tokens: AuthTokens) => {
    writeStored({ customerId, tokens });
  }, []);

  const signOut = useCallback(() => {
    clearTokens();
  }, []);

  return {
    isAuthenticated: Boolean(state.customerId),
    customerId: state.customerId,
    tokens: state.tokens,
    signIn,
    signOut,
  };
}
